import { useEffect, useState } from 'react';
import type { FieldSorts } from '../@types/common';
import type { UserStructure } from '../@types/users';
import { useGetLinkedUsersByIdQuery } from '../redux/services/user';
import { mapLinkedRecordIds } from '../utils/linked-user-utils';

/**
 * A hook that fetches records of linked user fields, by linkedRecordIds and fields.
 * @param {string} fields
 * @param {number} page
 * @param {number} pageSize
 * @param {Array<number>} linkedRecordIds
 * @param {FieldSorts} sort
 * @returns {{linkedRecords: Array<UserResult>, isFetching: boolean}}
 */
const useFetchLinkedUsers = (
  fields: string,
  page: number,
  pageSize: number,
  linkedRecordIds?: Array<number>,
  sort?: FieldSorts
) => {
  const [linkedUsersRecords, setLinkedUsersRecords] = useState<Array<UserStructure>>([]);

  const { data: linkedUsersData, isFetching } = useGetLinkedUsersByIdQuery(
    { fields, linkedRecordIds: mapLinkedRecordIds(linkedRecordIds), page, pageSize, sort },
    {
      skip:
        linkedRecordIds === undefined ||
        linkedRecordIds.length === 0 ||
        fields === undefined ||
        page === undefined ||
        pageSize === undefined,
    }
  );

  useEffect(() => {
    if (linkedUsersData && !isFetching) {
      setLinkedUsersRecords(linkedUsersData);
    }
  }, [linkedUsersData, isFetching]);

  return {
    linkedUsersRecords,
    isFetching,
  };
};

export default useFetchLinkedUsers;
